import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { ApiService } from "@core/services";
import { ApiResponse, TimeoutConfig } from "@core/types";

const SERVER_API = {
  TIME_OUT_CONFIG: "/api/server/time-out-config",
  PING: "/api/server/ping",
};

@Injectable({ providedIn: "root" })
export class AppStatusService {
  private readonly api = inject(ApiService);

  /**
   * Health check - verify server is up and session is valid.
   * Used for keep-alive pings.
   */
  ping(): Observable<ApiResponse<void>> {
    return this.api.get<void>(SERVER_API.PING);
  }

  /**
   * Fetch session timeout configuration from server.
   * Called once on app startup.
   */
  getTimeoutConfig(): Observable<ApiResponse<TimeoutConfig>> {
    return this.api.get<TimeoutConfig>(SERVER_API.TIME_OUT_CONFIG);
  }
}
